import { css } from 'emotion'
// import { PRIMARY_BACKGROUND_COLOR } from 'constants/styleConstants'

export const MessageNotificationDropdownStyles = css`
  position: relative;
  height: 25px;

  .DropdownButton,
  .CommentSolidIcon {
    height: 25px;
  }

  > button {
    padding: 0 4px;
    position: relative;

    .CountBubbleWidget {
      position: absolute;
      top: -8px;
      right: -8px;
    }
  }

  .NotificationList {
    .title {
      font-size: 0.75em;
    }
  }

  .Dropdown {
    .chevronContainer {
      right: 3px;
    }

    .container {
      right: -54px;
    }
  }

  &.isMediumScreen {
    .Dropdown {
      .container {
        right: 0;
        width: 380px;
      }
    }
  }
`
